import { GHLLanguageKeys as a } from "./ghl-ui.es285.js";
import o from "./ghl-ui.es1277.js";
const m = {
  name: a.hungarian,
  locale: o
};
export {
  m as date_hu
};
